import * as React from 'react';

function HistoricalFinancials({data} :any) {
  return (
    <div className="col-lg-12 grid-margin stretch-card">
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Key Historical Financials</h4>
          <p className="card-description">
            Is <strong>{data.company_name}</strong> a wonderful business?  To find out, first look at the historical ROIC or ROE numbers in the table below.
            If ROIC or ROE is over 10% every year for the last 10 years this is good news, it means that the management is doing a great job.
            Don't forget about debt, the <strong>Debt Pay Off</strong> number calculates how many years it will take for the company to pay off its long-term debt using its current free cash flow.
            If the most recent Debt Pay off number is greater than 3 years, it means the management team may not be as good we thought in running this business.
            If it is 3 years or less, this is good news, Keep going...check the historical growth rate numbers above. <a href="https://decode-investing.medium.com/how-to-identify-a-wonderful-business-6f7afdc6a5c6">Learn more.</a>
          </p>
          <div className="table-responsive">
            <table className="table table-hover table-bordered table-sm">
              <thead>
                <tr>
                  <th className="table-dark"><strong>Year</strong></th>
                  <th className="table-dark"><strong>ROE</strong></th>
                  <th className="table-dark"><strong>ROIC</strong></th>
                  <th className="table-dark"><strong>Debt pay off</strong></th>
                  <th className="table-dark"><strong>LT Debt</strong></th>
                  <th className="table-dark"><strong>Free Cash Flow</strong></th>
                  <th className="table-dark"><strong>Operating Cash Flow</strong></th>
                  <th className="table-dark"><strong>Revenue</strong></th>
                  <th className="table-dark"><strong>EPS</strong></th>
                  <th className="table-dark"><strong>Equity</strong></th>
                </tr>
              </thead>
              <tbody>
                {data.financial_report?.map((item =>
                  <tr>
                    <td className="table-dark"><strong>{item.year}</strong></td>
                    <td className={ item.roe_color }>{item.roe}</td>
                    <td className={ item.roic_color }>{item.roic}</td>
                    <td className={ item.debt_to_fcf_color }>{(item.debt_to_fcf_human_value == '100 years') ? 'negative cash flow' : item.debt_to_fcf_human_value}</td>
                    <td>{item.long_term_debt?.human_value}</td>
                    <td>{item.free_cash_flow_human_value}</td>
                    <td>{item.cashflows_from_operations?.human_value}</td>
                    <td>{item.revenue?.human_value}</td>
                    <td>{item.eps?.human_value || item.eps_basic_diluted?.human_value}</td>
                    <td>{item.equity?.human_value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HistoricalFinancials;
